module.exports = __webpack_public_path__ + "static/media/arac-logo-white.758bf9bc.png";